import React from 'react';
import { BookCheck, CalendarDays, ShieldCheck, Sparkles, CircleCheck } from 'lucide-react';
const highlights = [{
  icon: BookCheck,
  title: '60+ clases',
  subtitle: 'listas para dar'
}, {
  icon: CalendarDays,
  title: '6 tomos',
  subtitle: 'con progresión anual'
}, {
  icon: ShieldCheck,
  title: 'Cuerpo Seguro Pro™',
  subtitle: 'incluido sin costo'
}];
const includes = ['+240 páginas de contenido estructurado', 'Clases, variaciones y cueings listos para usar', 'Planificación, fidelización y comunicación', 'Adaptaciones para grupos reales y heterogéneos'];
const levels = [{
  n: '01',
  label: 'Principiante'
}, {
  n: '02',
  label: 'Intermedio'
}, {
  n: '03',
  label: 'Avanzado'
}, {
  n: '04',
  label: 'Adultos Mayores'
}, {
  n: '05',
  label: 'Movilidad'
}, {
  n: '06',
  label: 'Full Relax'
}];
export function SystemOverview() {
  return <section className="w-full bg-[#062229] font-heading" aria-labelledby="system-title" data-id="element-50" data-mp="2fdfnm6whe6ji">
      <div className="mx-auto max-w-[1000px] px-6 py-20 sm:px-8 lg:py-24" data-id="element-51" data-mp="2abzzg5z0bjww">
        {/* Heading */}
        <h2 id="system-title" className="text-center text-[2.1rem] font-extrabold uppercase leading-[1.05] tracking-[-0.02em] text-white sm:text-5xl" data-id="element-52" data-mp="238gsh6vgbmpo">
          Stretching <span className="text-[#2DE3CE]" data-id="element-53" data-mp="2d5bonj495b0s">Resuelto™</span>
        </h2>
        <p className="mx-auto mt-4 max-w-[34ch] text-center text-lg leading-snug text-white/80 sm:max-w-[46ch] sm:text-xl" data-id="element-54" data-mp="2i2loztt6j73e">
          Un método completo para planificar, enseñar y verte tan profesional como sos.
        </p>

        {/* Highlight cards */}
        <ul className="mt-10 grid grid-cols-3 items-stretch gap-4 sm:gap-5" data-id="element-55" data-mp="1ue2f59uhem97">
          {highlights.map(({
          icon: Icon,
          title,
          subtitle
        }) => <li key={title} className="flex flex-col items-center rounded-2xl border border-white/[0.07] bg-[#08282F] px-4 py-6 text-center sm:px-6 sm:py-7" data-id="element-56" data-mp="1z5u4xi5tcnya">
              <Icon className="h-7 w-7 text-[#2DE3CE]" aria-hidden="true" strokeWidth={1.8} data-id="element-57" data-mp="16n6s0q0z0f8a" />
              <p className="mt-4 text-base font-bold leading-tight text-white sm:text-xl" data-id="element-58" data-mp="ymqpngrjmo70">{title}</p>
              <p className="mt-1.5 text-[13px] leading-snug text-white/55 sm:text-base" data-id="element-59" data-mp="tnnx2vsr2afx">{subtitle}</p>
            </li>)}
        </ul>

        {/* Main box */}
        <div className="mt-10 overflow-hidden rounded-[28px] border border-white/[0.07] bg-[#07242B]" data-id="element-60" data-mp="13esb9talpr9p">
          {/* Top block */}
          <div className="border-b border-white/[0.07] px-6 py-9 sm:px-10 sm:py-10" data-id="element-61" data-mp="fpzbtmurt1ac">
            <h3 className="flex items-center gap-4 text-2xl font-bold text-white sm:text-3xl" data-id="element-62" data-mp="aqmpr4bq3y8t">
              <Sparkles className="h-8 w-8 shrink-0 text-[#2DE3CE]" aria-hidden="true" strokeWidth={1.8} data-id="element-63" data-mp="pndp5dled9yf" />
              Todo lo que necesitás, listo
            </h3>
            <ul className="mt-7 flex flex-col gap-5" data-id="element-64" data-mp="212928v4eb3cv">
              {includes.map(item => <li key={item} className="flex items-center gap-4" data-id="element-65" data-mp="2143lm500qneu">
                  <CircleCheck className="h-6 w-6 shrink-0 text-[#2DE3CE]" aria-hidden="true" strokeWidth={1.8} data-id="element-66" data-mp="1w2o60sgm193u" />
                  <span className="text-[15px] leading-relaxed text-white/90 sm:text-lg" data-id="element-67" data-mp="28ncy473tn284">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Bottom block */}
          <div className="px-6 py-9 sm:px-10 sm:py-10" data-id="element-68" data-mp="1yo46vm0cc1pg">
            <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-[#2DE3CE] sm:text-sm" data-id="element-69" data-mp="2mcoi54ellzyb">
              Niveles y enfoques incluidos
            </p>
            <ul className="mt-6 grid grid-cols-2 gap-4 sm:gap-5" data-id="element-70" data-mp="2redt6k1tmdme">
              {levels.map(({
              n,
              label
            }) => <li key={n} className="flex items-center gap-3 rounded-2xl border border-white/[0.07] bg-[#04191F] px-4 py-4 sm:px-5" data-id="element-71" data-mp="2hmghzdatblno">
                  <span className="rounded-lg bg-[#2DE3CE]/12 px-2 py-1 text-xs font-bold text-[#2DE3CE] sm:text-sm" data-id="element-72" data-mp="35a7tieoj3unw">
                    {n}
                  </span>
                  <span className="text-[15px] font-medium text-white sm:text-lg" data-id="element-73" data-mp="1mf8xzwlxgup3">{label}</span>
                </li>)}
            </ul>
            <p className="mt-7 text-[15px] leading-relaxed text-white/60 sm:text-lg" data-id="element-74" data-mp="1cg9sgmwglf6b">
              6 tomos conectados para que cada alumno avance, se sienta acompañado y quiera seguir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}